module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "es-mycard-select_design"
  }, [_c('app-header', {
    attrs: {
      "hide-shadow": "hide-shadow"
    }
  }), _c('es-my-card-sub-menu'), _vm._m(0), (_vm.getCardBaseDesignsEnd) ? _c('div', [_c('div', {
    staticClass: "es-mycard-select_design__content"
  }, [_vm._m(1), _c('div', {
    staticClass: "es-mycard-select_design__content-image"
  }, [_c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.mainDisplayCardBaseDesigns), function(baseCard) {
    return _c('swiper-slide', {
      staticClass: "es_mycard_background"
    }, [_c('div', {
      staticClass: "swiper-slide"
    }, [_c('div', {
      staticClass: "card-image",
      on: {
        "click": function($event) {
          _vm.goPreview(baseCard)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.getBackgroundImageByImageName(baseCard.background_path)
      }
    }), _c('img', {
      staticClass: "image_1",
      attrs: {
        "src": _vm.getCharacter1ImageByImageName(baseCard.character_1_folder_path, baseCard.character_1_path)
      }
    }), _c('img', {
      staticClass: "image_2",
      attrs: {
        "src": _vm.getCharacter2ImageByImageName(baseCard.character_2_path)
      }
    }), _c('p', [_vm._v("ありがとうを"), _c('br'), _vm._v("伝えるニャン♪")])])])])
  }), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 2)], 1), _c('button', {
    staticClass: "btn02 -stepup-modify",
    on: {
      "click": function($event) {
        _vm.goPreviewByBaseCarousel()
      }
    }
  }, [_c('span', [_vm._v("このベースデザインにする")])])]), (_vm.cardHistory.length > 0) ? _c('div', {
    staticClass: "es-mycard-select_design__content"
  }, [_vm._m(2), _c('div', {
    staticClass: "es-mycard-select_design__content-image"
  }, [_c('swiper', {
    ref: "historyMySwiper",
    attrs: {
      "options": _vm.usedDesignSwiperOption
    }
  }, [_vm._l((_vm.cardHistory), function(baseCard) {
    return _c('swiper-slide', {
      staticClass: "es_mycard_background"
    }, [_c('div', {
      staticClass: "swiper-slide"
    }, [_c('div', {
      staticClass: "card-image",
      on: {
        "click": function($event) {
          _vm.goPreview(baseCard)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.getBackgroundImageByImageName(baseCard.background_path)
      }
    }), _c('img', {
      staticClass: "image_1",
      attrs: {
        "src": _vm.getCharacter1ImageByImageName(baseCard.character_1_folder_path, baseCard.character_1_path)
      }
    }), _c('img', {
      staticClass: "image_2",
      attrs: {
        "src": _vm.getCharacter2ImageByImageName(baseCard.character_2_path)
      }
    }), _c('p', [_vm._v("ありがとうを"), _c('br'), _vm._v("伝えるニャン♪")])])])])
  }), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 2)], 1), _c('button', {
    staticClass: "btn02 -stepup-modify",
    on: {
      "click": function($event) {
        _vm.goPreviewByHistoryCarousel()
      }
    }
  }, [_c('span', [_vm._v("このベースデザインにする")])])]) : _vm._e(), _c('div', {
    staticClass: "es-mycard-select_design__content"
  }, [_vm._m(3), _c('div', {
    staticClass: "es_mycard_select_design__content-base-image"
  }, _vm._l((_vm.allCardBaseDesign), function(baseCard) {
    return _c('div', {
      staticClass: "base-image-card",
      on: {
        "click": function($event) {
          _vm.goPreview(baseCard)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.getBackgroundImageByImageName(baseCard.background_path)
      }
    }), _c('img', {
      staticClass: "image_1",
      attrs: {
        "src": _vm.getCharacter1ImageByImageName(baseCard.character_1_folder_path, baseCard.character_1_path)
      }
    }), _c('img', {
      staticClass: "image_2",
      attrs: {
        "src": _vm.getCharacter2ImageByImageName(baseCard.character_2_path)
      }
    }), _vm._m(4, true)])
  }), 0)])]) : _vm._e(), _c('button', {
    staticClass: "hide",
    attrs: {
      "id": "draftModalButton",
      "type": "button",
      "data-backdrop": "static",
      "data-toggle": "modal",
      "data-target": "#draftModal"
    }
  }, [_vm._v("モーダル発火用")]), _c('div', {
    staticClass: "help-modal",
    attrs: {
      "id": "draftModal"
    }
  }, [_c('div', {
    staticClass: "help-modal__body bg03",
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_vm._m(5), _vm._m(6), _c('div', {
    staticClass: "modal-main__buttons",
    staticStyle: {
      "justify-content": "center",
      "margin-top": "20px"
    }
  }, [_c('button', {
    staticClass: "btn01 -home-style",
    staticStyle: {
      "background": "#1989f1",
      "border-radius": "10px"
    },
    on: {
      "click": function($event) {
        _vm.resumeDraft()
      }
    }
  }, [_c('span', [_vm._v("下書きから再開")])]), _c('button', {
    staticClass: "btn02",
    staticStyle: {
      "margin-top": "20px",
      "background-color": "#fff"
    },
    on: {
      "click": function($event) {
        _vm.startFresh()
      }
    }
  }, [_c('span', [_vm._v("下書きを破棄して作成")])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "es-mycard-select_design__header"
  }, [_c('div', [_c('p', {
    staticClass: "fz15 bold"
  }, [_vm._v("まずはベースデザインを選んでだニャン♪")]), _c('p', {
    staticClass: "fz10"
  }, [_vm._v("いろんなデザインがあるんだニャン♪")])]), _c('div', {
    staticClass: "es-mycard-select_design__header--image"
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_cat_36.png"),
      "alt": "選んでだニャン"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "es-mycard-select_design__content-title"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("背景以外は後から変更できるニャン♪")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "es-mycard-select_design__content-title"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("過去にあなたが使ったカードデザイン")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "es-mycard-select_design__content-title"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("いろんなベースデザインがあるニャン♪")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("ありがとうを"), _c('br'), _vm._v("伝えるニャン♪")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "heading_01 mb25"
  }, [_vm._v("下書きデータが"), _c('br'), _vm._v("あるニャン♪")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box_01 help-modal__body__txt -login-done"
  }, [_c('p', [_vm._v("前回の続きから作成しますか？")]), _c('p', [_vm._v("それとも新しくカードを作成しますか？")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3567ebc1!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/es-mycard-select_design.pug
// module id = 1389
// module chunks = 1